export default [
    {
        title: "實習生招募有學生身份或年齡限制嗎？",
        content: "新芽實習生招募沒有學生身份或年齡上的限制，只要自行評估可行，我們都非常歡迎你投遞履歷",
    },
    {
        title: "排班至少三天是必要條件嗎？",
        content: "對的，期望每週一至五至少能排班三個整天",
    },
    {
        title: "是否會開放寒／暑期的實習機會呢？",
        content: "目前沒有開放，因為我們期望的實習期間為一年，但也樂見為期半年",
    },
    {
        title: "實習生招募期限到什麼時候呢？",
        content: "沒有設定招募期限，職缺招募到合適人選後，內部就會關閉職缺",
    },
    {
        title: "實習生職缺有限制只能投遞一個嗎？",
        content: "沒有限制只能投遞一個職缺，但是希望能確立方向後再投遞職缺",
    },
    {
        title: "實習期滿後是否有機會轉正呢？",
        content: "有的，會看你實習期間的表現及實習期滿後內部的正職職缺狀況再進行全方位的評估",
    },
    {
        title: "為什麼沒有看到職缺相對應的實習心得呢？",
        content: "每年實習生招募職缺都會按照內部狀況調整或新增，若無看到對應實習心得，可以參考職缺介紹來了解",
    },
    {
        title: "如何確認履歷有成功送出呢？",
        content: "成功投遞後會顯示「投遞完成」頁面，代表你的履歷已經成功送出囉！",
    },
    {
        title: "如已投遞履歷，但想更新內容或新增作品集，該怎麼做呢？",
        content: "投遞前請仔細檢查各欄位後再送出履歷，如投遞後想補充或更改資訊請直接重新投遞",
    },
    {
        title: "想投遞的職缺點入後沒有顯示投遞頁面，是否已招募完畢？",
        content: "職缺招募到合適人選後，內部就會關閉職缺，如無法成功開啟投遞網頁，會自動跳轉至職缺總覽頁面，就代表該職缺已招募完畢",
    },
    {
        title: "投遞實習生履歷後，一直沒有收到回覆，多久會收到進一步的通知？",
        content: "我們採先投先審制，建議有意願就盡快投遞履歷，因實習生計畫投遞人數較多，內部會需要一段時間審核履歷，如有進一步通知都會以 Email 聯繫，不論面試結果如何都會予以回覆！若無收到面試邀約者， HR 後續將不另行通知唷！",
    }
];



// WEBPACK FOOTER //
// ./src/models/Qa.js